// extracted by mini-css-extract-plugin
module.exports = {"component":"main-menu_component_2-ON5","button-wrapper":"main-menu_button-wrapper_AjKQf","button":"main-menu_button_3Xhtj"};